import { KYMW0C00Model } from '../kymw0c00.model';
import { PlessResponderSub } from '../../../../commons/kymw00/pless-responder-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像作成指示画面　画像情報管理を取得するサービス
 *
 * @export GetImageNameService
 * @class GetImageNameService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetImageNameService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetImageNameService
   */
  private model: KYMW0C00Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetImageNameService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetImageNameService
   */
  execute(model: any, successFunc: Function): void {
    this.model = <KYMW0C00Model>model;
    this.successFunc = successFunc;
    this.send('KYMW0C00GetImageName', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageNameService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
